export const productsEn: Record<string, string> = {
  // Products page
  'products.title': 'Products',
  'products.description': 'Manage your products and inventory',
  'products.showing': 'Showing {from}-{to} of {total} products',
  'products.actions.import': 'Import',
  'products.actions.export': 'Export',
  'products.actions.addProduct': 'Add Product',
  'products.actions.edit': 'Edit',
  'products.actions.retry': 'Retry',

  // Product labels
  'products.labels.stock': 'Stock',
  'products.labels.sku': 'SKU',
  'products.labels.notAvailable': 'N/A',
  'products.labels.orders': 'Orders',
  'products.labels.order': 'order',

  // Product categories
  'products.categories.dress': 'Dress',
  'products.categories.veil': 'Veil',
  'products.categories.accessory': 'Accessory',
  'products.categories.service': 'Service',
  'products.categories.shoes': 'Shoes',
  'products.categories.jewelry': 'Jewelry',
  'products.categories.bag': 'Bag',
  'products.categories.underwear': 'Underwear',
  'products.categories.wedding-dress': 'Wedding Dress',
  'products.categories.evening-dress': 'Evening Dress',
  'products.categories.groom-suits': 'Groom Suits',
  'products.categories.bridal-shoes': 'Bridal Shoes',
  'products.categories.bridesmaid-dress': 'Bridesmaid Dress',
  'products.categories.mother-of-bride': 'Mother of Bride',
  'products.categories.bridal-lingerie': 'Bridal Lingerie',
  'products.categories.bridal-jewelry': 'Bridal Jewelry',
  'products.categories.bridal-accessories': 'Bridal Accessories',
  'products.categories.alteration-services': 'Alteration Services',

  // Collection Years
  'products.collectionYears.2020-2021': '2020-2021',
  'products.collectionYears.2021-2022': '2021-2022',
  'products.collectionYears.2022-2023': '2022-2023',
  'products.collectionYears.2023-2024': '2023-2024',
  'products.collectionYears.2024-2025': '2024-2025',
  'products.collectionYears.2025-2026': '2025-2026',
  'products.collectionYears.2026-2027': '2026-2027',
  'products.collectionYears.2027-2028': '2027-2028',

  // Product table headers
  'products.table.image': 'Image',
  'products.table.product': 'Product',
  'products.table.category': 'Category',
  'products.table.brand': 'Brand',
  'products.table.price': 'Price',
  'products.table.stock': 'Stock',
  'products.table.actions': 'Actions',
  'products.table.orders': 'Orders',
  'products.table.sku': 'SKU',
  'products.table.name': 'Name',
  'products.table.sellingPrice': 'Selling Price',
  'products.table.costPrice': 'Cost Price',
  'products.table.internalNote': '(internal)',
  'products.search.placeholder': 'Search products...',
  'products.filters.title': 'Filters',
  'products.filters.clearAll': 'Clear All',
  'products.filters.searchLabel': 'Search',
  'products.filters.search': 'Search products...',
  'products.filters.searchByNameBrandSku': 'Search by name, brand, or SKU...',
  'products.filters.searchBadge': 'Search: {query}',
  'products.filters.noResults': 'No products found matching your filters',
  'products.filters.activeFilters': 'Active filters:',
  'products.filters.category': 'Category',
  'products.filters.brand': 'Brand',
  'products.filters.color': 'Color',
  'products.filters.sellingPriceRange': 'Selling Price Range (€)',
  'products.filters.costPriceRange': 'Cost Price Range (€)',
  'products.filters.priceRangeLabel': 'Price Range: EUR {min} - EUR {max}',
  'products.filters.costPriceRangeLabel': 'Cost Price Range: EUR {min} - EUR {max}',
  'products.filters.priceBadge': 'Price: EUR {min} - {max}',
  'products.filters.infinity': 'No max',
  'products.filters.advancedFilters': 'Advanced Filters',
  'products.filters.sizeRange': 'Size Range',
  'products.filters.supplier': 'Supplier',
  'products.filters.stockOptions': 'Stock Options',
  'products.filters.stockAvailableRange': 'Stock Available Range',
  'products.filters.quantityOnHandRange': 'Quantity on Hand Range',
  'products.filters.orderCountRange': 'Order Count Range',
  'products.filters.collectionYear': 'Collection Year',
  'products.filters.allCollectionYears': 'All collection years',
  'products.filters.min': 'Min',
  'products.filters.max': 'Max',
  'products.filters.allCategories': 'All categories',
  'products.filters.allBrands': 'All brands',
  'products.filters.allColors': 'All colors',
  'products.filters.allSizes': 'All sizes',
  'products.filters.allSuppliers': 'All suppliers',
  'products.filters.allProducts': 'All products',
  'products.filters.trackStock': 'Track Stock',
  'products.filters.allowNegative': 'Allow Negative',
  'products.filters.allowNegativeStock': 'Allow Negative Stock',
  'products.filters.hasImages': 'Has Images',
  'products.filters.imageFilter': 'Image Filter',
  'products.filters.withImages': 'With images',
  'products.filters.withoutImages': 'Without images',
  'products.filters.noBrand': 'No Brand',
  'products.filters.selling': 'Selling',
  'products.filters.cost': 'Cost',
  'products.filters.minCurrency': 'Min EUR',
  'products.filters.maxCurrency': 'Max EUR',
  'products.filters.loadError': 'Failed to load filter options',
  'products.filters.loadErrorSub': 'Some filters may not be available',
  'products.filters.apply': 'Apply',
  'products.sort.recentlyUpdated': 'Recently Updated',
  'products.sort.nameAsc': 'Name A-Z',
  'products.sort.nameDesc': 'Name Z-A',
  'products.sort.priceAsc': 'Price Low to High',
  'products.sort.priceDesc': 'Price High to Low',
  'products.sort.recentlyCreated': 'Recently Created',
  'products.sort.ordersAsc': 'Orders (Low to High)',
  'products.sort.ordersDesc': 'Orders (High to Low)',
  'products.empty.title': 'No products found',
  'products.empty.withFilters': 'No products match your current filters.',
  'products.empty.noFilters': "You don't have any products yet. Create one to get started.",
  'products.empty.clearFilters': 'Clear Filters',
  'products.empty.createProduct': 'Create Product',
  'products.errors.loadingTitle': 'Error Loading Products',
  'products.errors.loadingDescription': 'There was an error loading products',
  'products.errors.tryAgain': 'Try Again',
  'products.errors.loadFailed': 'Failed to load products',
  'products.errors.nameRequired': 'Product name is required',
  'products.errors.duplicateSku': 'SKU already exists. Please use a unique SKU.',
  'products.errors.permissionDenied': 'Permission denied. Please check your organization settings.',
  'products.errors.missingField': 'Missing required field. Please check all required fields.',
  'products.errors.invalidSupplier': 'Invalid supplier selected. Please choose a valid supplier.',
  'products.errors.updateFailed': 'Failed to update product',
  'products.errors.cannotDelete': 'Cannot Delete',
  'products.errors.referencedByOrders': 'This product is referenced by existing orders and cannot be deleted',
  'products.errors.deleteFailed': 'Failed to delete product',
  'products.errors.noCostPricePermission': 'No permission to view cost price',
  'products.pagination.show': 'Show',
  'products.pagination.perPage': 'per page',
  'products.export.success': 'Export Successful',
  'products.export.successDescription': '{count} products exported successfully',
  'products.export.error': 'Export Error',
  'products.export.errorDescription': 'There was an error exporting products',
  'products.export.noData': 'No Data to Export',
  'products.export.noDataDescription': 'No products to export with current filters',
  'products.import.success': 'Import Successful',
  'products.import.successDescription': 'Products imported successfully',
  'products.import.title': 'Import Products',
  'products.import.dragDrop': 'Drag and drop your CSV file here, or',
  'products.import.selectFile': 'select file',
  'products.import.supportedFormats': 'Supported formats: CSV (max 10MB)',
  'products.import.csvTemplate': 'Download CSV Template',
  'products.import.requirements': 'File Requirements',
  'products.import.req1': 'File must be in CSV format',
  'products.import.req2': 'Required columns: Name, SKU, Category, Price',
  'products.import.req3': 'SKUs must be unique',
  'products.import.req4': 'Prices must be valid numbers',
  'products.import.cancel': 'Cancel',
  'products.import.import': 'Import Products',
  'products.import.processing': 'Processing...',
  'products.import.error': 'Import error',
  'products.import.uploadDescription': 'Upload your CSV file to preview and validate the data before importing.',
  'products.import.templateDescription': 'Download the CSV template with sample data and formatting guidelines.',
  'products.import.downloadTemplate': 'Download Template',
  'products.import.createMissingSuppliers': 'Create missing suppliers automatically',
  'products.import.invalidFileType': 'Invalid file type',
  'products.import.selectCsvFile': 'Please select a CSV file',
  'products.import.fileTooLarge': 'File too large',
  'products.import.fileSizeLimit': 'CSV files up to 10MB supported',
  'products.import.permissionDenied': 'Permission denied',
  'products.import.productsWriteRequired': 'Products write permission required',
  'products.import.suppliersWriteRequired': 'Suppliers write permission required for creating missing suppliers',
  'products.import.authRequired': 'Authentication required',
  'products.import.loginRequired': 'Please log in to download error report',
  'products.import.downloadErrorReport': 'Download Error Report',
  'products.import.errorReportDownloaded': 'Error report downloaded',
  'products.import.errorReportDownloadSuccess': 'Error report has been downloaded successfully',
  'products.import.downloadFailed': 'Download failed',
  'products.import.errorReportDownloadFailed': 'Failed to download error report',
  'products.import.previewGenerated': 'Preview generated',
  'products.import.previewDescription': 'Loaded {rows} rows for preview',
  'products.import.importCompleted': 'Import completed',
  'products.import.importSuccessDescription': 'Created {created}, updated {updated} products',
  'products.import.importFailed': 'Import failed',
  'products.import.previewData': 'Preview Data',
  'products.import.importing': 'Importing...',
  'products.import.importProducts': 'Import {count} Products',
  'products.import.toCreate': 'to create',
  'products.import.toUpdate': 'to update',
  'products.import.errors': 'errors',
  'products.import.readyToImport': 'Ready to import',
  'products.import.hasErrors': 'Has errors',
  'products.import.importingProducts': 'Importing products...',
  'products.import.importSuccess': 'Import completed successfully! Your products have been added to the catalog.',
  'products.import.created': 'Created',
  'products.import.updated': 'Updated',
  'products.import.viewProducts': 'View Products',
  'products.import.rowNumber': 'Row',
  'products.import.status': 'Status',
  'products.import.name': 'Name',
  'products.import.category': 'Category',
  'products.import.price': 'Price',
  'products.import.message': 'Message',
  'products.import.statusCreate': 'Create',
  'products.import.statusUpdate': 'Update',
  'products.import.statusError': 'Error',
  'products.import.templateTab': 'Template',
  'products.import.uploadTab': 'Upload',
  'products.import.previewTab': 'Preview',
  'products.import.resultsTab': 'Results',
  'products.import.requiredFields': 'Required fields: Name, Category, Price',
  'products.import.categories': 'Categories: Dress, Veil, Accessory, Service',
  'products.import.booleans': 'Booleans: TRUE/FALSE, true/false, yes/no, 1/0',
  'products.import.services': 'Services: Automatically set as non-stock items',
  'products.import.uploadFilePrompt': 'Click to upload CSV file',
  'products.import.fileSizeSupport': 'CSV files up to 10MB supported',
  'products.import.mobileNote': 'Showing key fields only on mobile. Full details available on desktop.',
  'products.import.row': 'Row',
  'import.template.downloaded': 'Template downloaded',
  'import.template.downloadSuccess': 'CSV template has been downloaded successfully',
  'import.preview.status.ok': 'Create',
  'import.preview.status.update': 'Update',
  'import.preview.status.error': 'Error',
  'import.preview.noData': 'No preview data available',
  'import.preview.mobileNote': 'Mobile preview shows key fields only',
  'import.preview.row': 'Row',
  'products.csvHeaders.name': 'Name',
  'products.csvHeaders.sku': 'SKU',
  'products.csvHeaders.category': 'Category',
  'products.csvHeaders.brand': 'Brand',
  'products.csvHeaders.price': 'Price',
  'products.csvHeaders.costPrice': 'Cost Price',
  'products.csvHeaders.quantityOnHand': 'Quantity On Hand',
  'products.csvHeaders.sizeRange': 'Size Range',
  'products.csvHeaders.colour': 'Colour',
  'products.csvHeaders.supplierId': 'Supplier ID',
  'products.csvHeaders.description': 'Description',
  'products.csvHeaders.createdAt': 'Created At',
  'products.csvHeaders.updatedAt': 'Updated At',
  'products.stats.hide': 'Hide stats',
  'products.stats.show': 'Show stats',
  'products.stats.totalProducts': 'Total Products',
  'products.stats.lowStock': 'Low Stock',
  'products.stats.outOfStock': 'Out of Stock',
  'products.stats.withImages': 'With Images',
  'products.stats.noImages': 'No Images',
  'products.stats.noBrand': 'No Brand',
  'products.columns.toggle': 'Columns',

  // Product Create Modal
  'products.create.title': 'Create New Product',
  'products.create.name': 'Product Name',
  'products.create.namePlaceholder': 'Enter product name',
  'products.create.sku': 'SKU',
  'products.create.skuPlaceholder': 'DRESS001',
  'products.create.category': 'Category',
  'products.create.categoryPlaceholder': 'Select category',
  'products.create.brand': 'Brand',
  'products.create.brandPlaceholder': 'Select brand',
  'products.create.brandDeprecated': 'Brand (Deprecated)',
  'products.create.brandDeprecatedPlaceholder': 'Optional legacy brand text',
  'products.create.colour': 'Colour',
  'products.create.colourPlaceholder': 'Enter colour',
  'products.create.sizeRange': 'Size Range',
  'products.create.sizeRangePlaceholder': '6-20',
  'products.create.price': 'Price',
  'products.create.pricePlaceholder': '0.00',
  'products.create.costPrice': 'Cost Price',
  'products.create.costPricePlaceholder': '0.00',
  'products.create.trackStock': 'Track Stock',
  'products.create.allowNegativeStock': 'Allow Negative Stock',
  'products.create.stockAvailable': 'Stock Available',
  'products.create.quantityOnHand': 'Quantity on Hand',
  'products.create.supplier': 'Supplier',
  'products.create.supplierPlaceholder': 'Select supplier',
  'products.create.collection': 'Collection',
  'products.create.collectionPlaceholder': 'Enter collection name',
  'products.create.collectionYear': 'Collection Year',
  'products.create.collectionYearPlaceholder': 'Select collection year',
  'products.create.description': 'Description',
  'products.create.descriptionPlaceholder': 'Enter product description',
  'products.create.cancel': 'Cancel',
  'products.create.creating': 'Creating...',
  'products.create.create': 'Create Product',
  'products.create.success': 'Product created successfully',
  'products.create.error': 'Error creating product',
  'products.create.trackStockDescription': 'Monitor inventory levels',
  'products.create.allowNegativeDescription': 'Allow overselling',

  // Product tabs
  'products.tabs.details': 'Product Details',
  'products.tabs.images': 'Images',

  // Product Images
  'products.images.title': 'Product Images',
  'products.images.primary': 'Primary',
  'products.images.uploadButton': 'Upload Images',
  'products.images.uploadInstructions': 'Select multiple • Max 5MB each',
  'products.images.manage': 'Manage Images',
  'products.images.tooManyFiles': 'Too many files',
  'products.images.tooManyFilesDesc': 'Can only upload {count} more image(s). Maximum 8 images per product.',
  'products.images.invalidFiles': 'Invalid files',
  'products.images.invalidFilesDesc': '{count} file(s) are too large (>5MB) or not images',
  'products.images.uploaded': 'Images uploaded',
  'products.images.uploadedDesc': 'Successfully uploaded {count} image(s)',
  'products.images.partialUpload': 'Partial upload',
  'products.images.uploadFailed': 'Upload failed',
  'products.images.uploadFailedDesc': 'Failed to upload any images',
  'products.images.primaryUpdated': 'Primary image updated',
  'products.images.primaryUpdatedDesc': 'Primary image set successfully',
  'products.images.deleted': 'Image deleted',
  'products.images.deletedDesc': 'Product image deleted successfully',
  'products.images.deleteFailed': 'Delete failed',
  'products.images.deleteFailedDesc': 'Failed to delete image',
  'products.images.updateFailed': 'Update failed',
  'products.images.updateFailedDesc': 'Failed to update image position',
  'products.images.uploading': 'Uploading...',
  'products.images.files': '{count} file(s)',
  'products.images.uploadingFiles': 'Uploading Files',
  'products.images.failed': 'Failed',
  'products.images.noImages': 'No images uploaded',
  'products.images.noImagesDesc': 'Upload images to showcase your product',
  'products.images.description': '{current} of {max} images',
  'products.images.createFirst': 'Create the product first to manage images',

  // Product Edit Modal
  'products.edit.title': 'Edit Product',
  'products.edit.cancel': 'Cancel',
  'products.edit.updating': 'Updating...',
  'products.edit.update': 'Update Product',
  'products.edit.success': 'Product updated successfully',
  'products.edit.error': 'Error updating product',
  'products.edit.unsavedChanges': 'Unsaved changes',
  'products.edit.discard': 'Discard',
  'products.edit.noImages': 'No images',
  'products.edit.loadingImages': 'Loading...',

  // Product Sections
  'products.sections.basicInfo': 'Basic Info',
  'products.sections.attributes': 'Attributes',
  'products.sections.pricing': 'Pricing & Supplier',
  'products.sections.stock': 'Stock Management',

  // Product Delete
  'products.delete.success': 'Product deleted successfully',
  'products.delete.error': 'Error deleting product',
  'products.delete.confirmTitle': 'Delete product?',
  'products.delete.confirmDescription': 'This action cannot be undone. This will permanently delete the product and all associated data.',
  'products.delete.confirm': 'Delete',

  // Product Detail misc
  'products.notFound': 'Product not found',
  'products.backToProducts': 'Back to Products',
  'products.margin': 'Margin',
  'products.noTracking': 'No tracking',
  'products.createTitle': 'Create New Product',
  'products.editTitle': 'Edit Product',
  'products.deleteTitle': 'Delete Product',
  'products.deleteConfirmation': 'Are you sure you want to delete this product? This action cannot be undone.',
  'products.actions.exportCsv': 'Export CSV',
  'products.actions.importCsv': 'Import CSV',
  'products.actions.newProduct': 'New Product',
  'products.actions.createProduct': 'Create Product',
  'products.actions.updateProduct': 'Update Product',
  'products.success.created': 'Product created successfully',
  'products.success.updated': 'Product updated successfully',
  'products.success.deleted': 'Product deleted successfully',

  // Products page - fields & labels
  'products.fields.name': 'Name*',
  'products.fields.category': 'Category*',
  'products.fields.brand': 'Brand',
  'products.fields.colour': 'Colour',
  'products.fields.sizeRange': 'Size Range',
  'products.fields.sellingPrice': 'Selling Price (€)',
  'products.fields.costPrice': 'Cost Price (€)',
  'products.fields.internalOnly': '(Internal only)',
  'products.fields.supplier': 'Supplier',
  'products.fields.trackStock': 'Track Stock',
  'products.fields.allowNegative': 'Allow Negative Stock',
  'products.fields.stockAvailable': 'Stock Available',
  'products.fields.quantityOnHand': 'Quantity on Hand',
  'products.fields.description': 'Description',
  'products.placeholders.name': 'Elegant A-Line Dress',
  'products.placeholders.supplier': 'Select supplier (optional)',
  'products.debug.current': 'Current',
  'products.debug.total': 'Total',

  // Legacy product keys
  'new_product': 'New Product',
  'export_csv': 'Export CSV',
  'export': 'Export',
  'create_new_product': 'Create New Product',
  'edit_product': 'Edit Product',
  'sku_required': 'SKU*',
  'style_name_required': 'Style Name*',
  'style_name': 'Style Name',
  'sku_placeholder': 'DRESS001',
  'style_name_placeholder': 'Elegant A-Line Dress',
  'brand_placeholder': 'Vera Wang',
  'colour_placeholder': 'Ivory',
  'size_range': 'Size Range',
  'size_range_placeholder': '6-20',
  'price_euro': 'Price (€)',
  'price_placeholder': '1500',
  'stock_available': 'Stock Available',
  'stock_placeholder': '1',
  'image_url': 'Image URL',
  'table_sku': 'SKU',
  'table_style_name': 'Style Name',
  'table_brand': 'Brand',
  'table_size_range': 'Size Range',
  'table_colour': 'Colour',
  'table_price': 'Price',
  'table_stock': 'Stock',
  'table_actions': 'Actions',
  'sku_already_exists': 'SKU already exists. Please use a unique SKU.',
  'product_referenced_orders': 'This product is referenced by existing orders and cannot be deleted',
  'product_created_successfully': 'Product created successfully',
  'product_updated_successfully': 'Product updated successfully',
  'product_deleted_successfully': 'Product deleted successfully',
  'failed_to_create_product': 'Failed to create product',
  'failed_to_update_product': 'Failed to update product',
  'failed_to_delete_product': 'Failed to delete product',
  'failed_to_fetch_products': 'Failed to fetch products',
  'confirm_delete_product': 'Are you sure you want to delete this product?',
  'no_products_found': 'No products found',

  // Import History
  'importHistory.title': 'Import History',
  'importHistory.quickDescription': 'View your recent product import activity',
  'importHistory.viewAll': 'View All',
};
